import React from "react";
import ReactDOM from "react-dom";

export const TextAreayModelPopUp=({id, title ,handleClose ,handleSubmit , data ,noteChange})=>{

    const modal = (
        <div
        id={id}
        className="modal custom-modal fade"
        role="dialog"
        data-bs-backdrop="static" data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-between align-items-center" style={{ height: "80px" }}>
              <h3 className="modal-title">{title}</h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() =>handleClose }
              >
                ×
              </button>
            </div>
            <div className="modal-body pt-3">
              <form
                onSubmit={handleSubmit} // Handle form submission
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  minHeight: "300px", // Adjust height for the main box
                  width: "100%" // Ensure full width
                }}
              >
                <div className="input-block mb-3 form-focus" style={{ width: "100%" }}>
                  <textarea
                    rows={5}
                    value={data ?? ""}// Allow for user input
                    onChange={noteChange} // Change handler
                    className="w-100"
                    style={{
                      backgroundColor: "#ffffff", // Change to white for user input
                      cursor: "text", // Change cursor to text for enabled textarea
                      resize: "none",
                      minHeight: "200px", // Minimum height for the textarea
                      height: "auto",
                      outline: 'none' // Remove outline for focused textarea
                    }}
                  />
                </div>
                {/* Ensure space between textarea and submit button */}
              </form>
              <div className="submit-section" style={{
                marginTop: "20px",
                width: "100%", textAlign: "center"
              }}>
                <button className="btn btn-primary submit-btn"
                  data-bs-dismiss={noteChange ? "modal" : undefined}
                  onClick={handleSubmit} style={{ width: "200px" }}>

                  Submit
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
    if (typeof document !== "undefined" && document.body) {
      return ReactDOM.createPortal(modal, document.body);
    }
    return modal;
}